import getInitialState from './initialState';

export default {
  errorLoggerStart: state => Object.assign(state, { startTime: Date.now(), isRunning: true }),

  errorLoggerStop: state => Object.assign(state, { endTime: Date.now(), isRunning: false }),

  incrementNumberOfAttempts: (state, index = 0) => {
    const numberOfAttemptsArrCpy = state.numberOfAttempts.slice();

    numberOfAttemptsArrCpy[index] = (numberOfAttemptsArrCpy[index] || 0) + 1;

    return Object.assign(state, { numberOfAttempts: numberOfAttemptsArrCpy });
  },

  incrementNumberOfChars: state => Object.assign(state, { numberOfChars: state.numberOfChars + 1 }),

  incrementNumberOfNonLetters: state =>
    Object.assign(state, { numberOfNonLetters: state.numberOfNonLetters + 1 }),

  setResponseData: (state, responseData) =>
    Object.assign(state, { responseData: responseData.slice(0) }),

  addToErrorArray: (state, error) => state.errorArray.push(error),

  resetErrorLogger: state => Object.assign(state, { ...getInitialState() })
};
